import { IGroupConfigurationData, IPharmacyORE } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";
import { ArrayToLookup } from "global/Utility/TSFunctions";

export class PharmacyResetTransformer extends BaseJsonTransformer {

    constructor() {
        super();
    }

    async after(json: IGroupConfigurationData): Promise<void> {

        const pharmacyORE: IPharmacyORE[] = [];

        const plans = ArrayToLookup(json.plans);

        json.pharmacyORE?.forEach(eachORE => {

            const hasPlan = plans[eachORE.id];

            // plan doesn't exists anymore, or it has been deactivated, since it will be removed next iteration
            if (!hasPlan || hasPlan.deactivated)
                return;

            const newObj: IPharmacyORE = {
                id: eachORE.id,
                pharmacyPlanDesign: eachORE.newPharmacyPlanDesign
                    ? eachORE.newPharmacyPlanDesign
                    : eachORE.pharmacyPlanDesign,
                newPharmacyPlanDesign: "",
                newClientNumber: "",
                releaseStatus: "In Progress"
            };

            pharmacyORE.push(newObj);
        });

        json.pharmacyORE = pharmacyORE;

        // TODO move this to removeDeactivatedData transformer
        if (json?.comments?.length > 0)
            json.comments = [];

    }

}
